import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    editProductDialog: false,
    editVariationDialog: false
}

export const dialogsSlice = createSlice({
    name: "dialogs",
    initialState: initialState,
    reducers: {
        setEditProducDialog: (state, action) => {
            state.editProductDialog = action.payload
        },
        setEditVariationDialog: (state, action) => {
            state.editVariationDialog = action.payload
        },
    }
})

export const {
    setEditProducDialog,
    setEditVariationDialog,
} = dialogsSlice.actions